import { render, staticRenderFns } from "./InvoiceProductsClasificationSelector.vue?vue&type=template&id=0e995408&scoped=true"
import script from "./InvoiceProductsClasificationSelector.vue?vue&type=script&lang=js"
export * from "./InvoiceProductsClasificationSelector.vue?vue&type=script&lang=js"
import style0 from "./InvoiceProductsClasificationSelector.vue?vue&type=style&index=0&id=0e995408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e995408",
  null
  
)

export default component.exports